import { render, staticRenderFns } from "./POILog.vue?vue&type=template&id=5b57d922&"
import script from "./POILog.vue?vue&type=script&lang=js&"
export * from "./POILog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports